import React from 'react';
import { Box, Typography } from '@saviynt/design-system';
import PropTypes from 'prop-types';

import Timeline from './Timeline';

import './CertsListSidePanelBodyCommon.css';

function HistoryCard({
  children,
  title,
  timelineColor,
  timelineKind,
  isTailVisible,
}) {
  return (
    <Box tag='div' className='HistoryCard'>
      <Timeline
        color={timelineColor}
        kind={timelineKind}
        isTailVisible={isTailVisible}
      />
      <Box tag='div' className='HistoryCard-content'>
        <Typography
          kind='body1-bold'
          desktop='body1-bold-d'
          mobile='body1-bold-d'
          color='--color-foreground-secondary-bold'
          lineLimit={1}>
          {`${title}`}
        </Typography>
        <Box tag='div' className='HistoryCard-contentBody'>
          {children}
        </Box>
      </Box>
    </Box>
  );
}

HistoryCard.propTypes = {
  children: PropTypes.node,
  title: PropTypes.string,
  timelineColor: PropTypes.string,
  timelineKind: PropTypes.string,
  isTailVisible: PropTypes.bool,
};

HistoryCard.defaultProps = {
  children: null,
  title: ' ',
  timelineColor: null,
  timelineKind: null,
  isTailVisible: true,
};

export default HistoryCard;
